import { Agency, User } from 'rest-client';

import { BookingMessage } from './auth.model';

export class SetUserAction {
  static readonly type = '[AUTH] Set user';
  constructor(public user: User) {}
}

export class SetAgencyAction {
  static readonly type = '[AUTH] Set agency';
  constructor(public agency: Agency) {}
}

export class RemoveAuthAction {
  static readonly type = '[AUTH] Remove user';
}

export class RemoveCompanyAction {
  static readonly type = '[AUTH] Remove company';
}
export class SetUserMessageAction {
  static readonly type = '[AUTH] Set user message';
  constructor(public message: BookingMessage) {}
}

export class RemoveUserMessageAction {
  static readonly type = '[AUTH] Remove user message';
}
